import { createSelector } from 'reselect';
import { statsLeadersSelector } from './simple-selectors';

export const statsLeadersRequestsSelector = createSelector(
    statsLeadersSelector,
    statsLeaders => statsLeaders.requests
);